import { BaseHttpService } from '../../../main/factories/http';
import { PostQuery } from 'domain/usecases';

export class RemotePostQuery extends BaseHttpService<PostQuery.Model> implements PostQuery {
  async postQuery(body: PostQuery.Params): Promise<PostQuery.Model> {
    return this.request('post', body);
  }
}
